import React, { Component } from 'react';
import Select from 'react-select';

// apis
import researchApi from '/src/apis/researchApi';
import taxonomyApi from '/src/apis/taxonomyApi';

// constants
import { WEB_URL } from "/src/utilities/endpoints";
import { ar, en } from "/src/utilities/constants/dictionary";
import { REPORT_TYPES, TAXONOMIES, RESEARCH_DOWNLOAD_FORM_TYPES, CAPTCHA_SITE_KEY } from '/src/utilities/constants';
import { sharedConstants } from 'shared-helpers';

// helpers
import { isValidEmail } from '/src/utilities/helpers';

// styles
const reactSelectSmall = sharedConstants.reactSelectSmall;
const reactSelectTheme = sharedConstants.reactSelectTheme;



const FORM_FIELDS = ['email', 'first_name', 'last_name', 'company_name', 'company_type', 'job_title'];
const PLACEHOLDER_DICTIONARY_KEYS = ["email", "firstName", "lastName", "companyName", "companyType", "jobTitle"];

export default class ResearchDownloadForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // taxonomy
            companyTypes: [],
            locations: [],
            userRoles: [],

            // form state
            isDownloading: false,
            dictionary: en(),

            // form field
            apiErrorMessage: false,
            domainInvalid: false,
            emailInvalid: false,
            errorMessages: [],
            formFields: FORM_FIELDS,
            formType: 'long',
            sub_to_mailchimp: true,
            captchaLoaded: false,
        };

        // init form fields and errors in state
        this.state.formFields.map((name) => {
            this.state[name] = '';
            this.state[name + "Error"] = false;
        })
    }

    componentDidMount = () => {
        this.getFormTypeAndLanguage();
        this.getTaxonomyList();
        this.waitForRecaptcha();
    }

    getFormTypeAndLanguage = () => {
        // get the form type - short or long
        const { data } = this.props;
        const intFormType = data && data.download_form_type ? data.download_form_type : 1;
        const strFormType = RESEARCH_DOWNLOAD_FORM_TYPES[intFormType];
        const isShortForm = (strFormType == "short");

        if (isShortForm) {
            const arrTemp = ['email', 'first_name'];

            this.setState({
                formFields: arrTemp,
                formType: strFormType
            });
        }

        const englishDictionary = en(isShortForm);
        const arabicDictionary  = ar(isShortForm);
        const dictionary = (data.lang == "ar") ? arabicDictionary : englishDictionary;
        this.setState({ dictionary });
    }

    getTaxonomyList = () => {
        // get company type options
        taxonomyApi.getTaxonomyType(TAXONOMIES.companyType).then(
            response => {
                if (!response?.length) return;

                const companyTypes = response.map(type => {
                    return { value: type.id, label: type.name };
                });
                this.setState({ companyTypes });
            }
        )
    }

    waitForRecaptcha = () => {
        if (typeof window === 'undefined') return;

        const checkRecaptcha = () => {
            if (window.grecaptcha && window.grecaptcha.ready) {
                window.grecaptcha.ready(() => {
                    this.setState({ captchaLoaded: true });
                });
            } else {
                setTimeout(checkRecaptcha, 100);
            }
        };

        checkRecaptcha();
    }

    executeRecaptcha = async () => {
        return new Promise((resolve, reject) => {
            if (!window.grecaptcha || !this.state.captchaLoaded) {
                reject('reCAPTCHA not loaded');
                return;
            }

            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(CAPTCHA_SITE_KEY, { action: 'download_form' })
                    .then((token) => {
                        resolve(token);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        });
    }

    Login(event) {
        const loginButton = document?.getElementById('headerLogin');
        if (loginButton) {
            loginButton.click();
        }
    }

    handleChange(event) {
        let obj = {
            apiErrorMessage: false
        };
        let { name, value } = event.target;
        let actualName  = name;
        let actualValue = value;

        if ((name == "email") && (this.state.emailInvalid)) {
            if (isValidEmail(event.target.value) || event.target.value == '') {
                obj['emailInvalid'] = false;
            } else {
                obj['emailInvalid'] = true;
            }
        }

        obj[name] = value;
        obj[actualName] = actualValue;
        this.setState(obj);
    }

    handleSelectChange = (field, option) => {
        this.setState({
            [field]: option
        });
    }

    handleDownloadLoggedOut = async () => {

        const { isDownloading } = this.state;
        if (isDownloading) {
            return;
        }

        if (this.validateFields()) {

            // note: we don't set isDownloading to false later as the page redirects when the operation completes
            this.setState({ isDownloading: true });

            try {
                // Execute reCAPTCHA to get token
                const captchaToken = await this.executeRecaptcha();

                const { data } = this.props;
                const { email, first_name, last_name, company_name, job_title, sub_to_mailchimp } = this.state;
                const company_type_id = this.state.company_type.value;
                let utmSource, utmMedium, utmCampaign;

                if (window.location.search) {
                    const params = new URLSearchParams(window.location.search);
                    utmSource = params.get('utm_source');
                    utmMedium = params.get('utm_medium');
                    utmCampaign = params.get('utm_campaign');
                }

                const userData = {
                    email,
                    first_name,
                    last_name,
                    company_name,
                    job_title,
                    company_type_id,
                    sub_to_mailchimp,
                    path: window.location.pathname,
                    utm_source: utmSource,
                    utm_medium: utmMedium,
                    utm_campaign: utmCampaign
                };

                const mailchimpData = [
                    {
                        email_address: email,
                        merge_fields: {
                            FNAME: first_name,
                            LNAME: last_name,
                            ROLE: job_title,
                            COUNTRY: ''
                        },
                        tags: ['Funding Insights', 'Market Intelligence', 'Weekly', 'Download'],
                        captcha_token: captchaToken,
                        user_id: this.props.user ? this.props.user.user_id : null
                    }
                ];

                let redirectUrl = `${WEB_URL}/download-success?id=${data.id}`;

                researchApi.handleLoggedOutDownload(userData, data.id, mailchimpData).then(
                    response => {
                        if (response.success) {
                            window.location.href = redirectUrl;
                        } else {

                            if (response.emailComplianceError) {
                                redirectUrl += `&complianceError=true`;
                                return window.location.href = redirectUrl;
                            }

                            this.setState({
                                isDownloading: false,
                                apiErrorMessage: true
                            });
                        }
                    }
                )
            } catch (error) {
                console.error('reCAPTCHA execution failed:', error);
                this.setState({
                    isDownloading: false,
                    apiErrorMessage: true
                });
            }

        }
    }

    validateFields = () => {
        let error_count = 0
        const { formFields } = this.state;
        const { user, data } = this.props;

        if (formFields) {
            formFields.map((item, i) => {

                let ind = this.state.errorMessages.indexOf(item)
                if (this.state[item] === '' || this.state[item] === undefined || this.state[item] === null) {
                    this.state[`${item}_error`] = true;
                    error_count = error_count + 1;
                    if (ind === -1) {
                        this.state.errorMessages.push(item);
                    }
                } else {
                    this.state[`${item}_error`] = false
                    if (ind > -1) {
                        this.state.errorMessages.splice(ind, 1);
                    }
                }
                
                if (item === "email") {
                    let email = this.state[item];
                    if (isValidEmail(email) || email == '') {
                        this.state.emailInvalid = false;
                        if (user && user.is_loggedin === false && data && data.type_id == REPORT_TYPES.paid) {
                            const domainName = email.slice(email.indexOf('@') + 1, email.lastIndexOf('.'));
                            const restrictedDomains = ['gmail', 'yahoo', 'hotmail', 'yandex', 'outlook', 'live', 'ymail', 'gmx', 'aol', 'msn'];

                            if (restrictedDomains.includes(domainName)) {
                                this.state.domainInvalid = true;
                                error_count = error_count + 1;
                            } else {
                                this.state.domainInvalid = false;
                            }
                        }
                    } else {
                        this.state.emailInvalid  = true;
                        this.state.domainInvalid = false;
                        error_count = error_count + 1;
                    }
                }

            })
            this.setState(this.state)
        }
        
        const status = (error_count > 0) ? false : true;
        return status;
    }

    renderDownloadForm = () => {
        const { data } = this.props;
        const { formFields, formType, companyTypes, dictionary } = this.state;
        const INPUT_HEIGHT = 37;

        return formFields.map((field, i) => {
            const placeHolder = PLACEHOLDER_DICTIONARY_KEYS[i];
            return (
                <div className="col-12" key={`form-${field}-${i}`}>
                    {field === "company_type" ?
                        <Select
                            key={`${field}-${i}`}
                            className={`${formType} react-select-input`}
                            placeholder={dictionary.companyType}
                            theme={reactSelectTheme}
                            styles={{
                                ...reactSelectSmall,
                                control: (provided, state) => ({
                                    ...provided,
                                    // when trying to make changes to the height of the Select input,
                                    // change the height and the min-height together
                                    minHeight: INPUT_HEIGHT,
                                    height: INPUT_HEIGHT,
                                    borderColor: "#eee",
                                    boxShadow: "none",
                                    fontSize: 14,
                                    marginBottom: 12,
                                    '&:hover': {
                                        borderColor: "#eee",
                                    }
                                }),
                                dropdownIndicator: (provided, state) => ({
                                    paddingTop: 0,
                                    marginTop: (data.lang === "en" ? -10 : -8),
                                    [(data.lang === "en" ? 'paddingRight' : 'paddingLeft')]: 7
                                }),
                                valueContainer: (provided, state) => ({
                                    [(data.lang === "en" ? 'marginLeft' : 'marginRight')]: 8
                                }),
                            }}
                            options={companyTypes}
                            value={this.state[field]}
                            onChange={(e) => this.handleSelectChange('company_type', e)}
                        />
                        :
                        <input
                            className={formType}
                            key={`${field}-${i}`}
                            type="text"
                            name={field}
                            placeholder={dictionary[placeHolder]}
                            value={this.state[field]}
                            onChange={(event) => {
                                this.setState({ [field + "Error"]: false });
                                this.handleChange(event)
                            }}
                        />
                    }
                </div>
            );
        })
    }

    renderFormFeedback = () => {
        const { data } = this.props;
        const { errorMessages, emailInvalid, domainInvalid, apiErrorMessage, dictionary } = this.state;
        const hasErrors = ((errorMessages.length > 0) || (emailInvalid) || (domainInvalid) || (apiErrorMessage));

        if (hasErrors) {
            let errorText = [];
            if (errorMessages.length > 0) {
                errorText.push(dictionary.invalidMissingFields)
            }
            if (emailInvalid) {
                errorText.push(dictionary.invalidEmail)
            }
            if (domainInvalid) {
                errorText.push(dictionary.invalidDomain)
            }
            if (apiErrorMessage) {
                errorText.push(dictionary.generalError)
            }

            return (
                <div className="error-feedback" lang={data.lang}>
                    {errorText.length > 0 ?
                        errorText.join('. ')
                        :
                        dictionary.generalError
                    }
                </div>
            )
        } else {
            return null;
        }
    }

    render() {

        const { data } = this.props;
        const { sub_to_mailchimp, isDownloading, dictionary } = this.state;
        const dir = (data.lang == "ar") ? "rtl" : "";

        return (
            <div className="standard-popup-form" lang={data.lang} dir={dir}>
                <div className="modal fade" id="researchDownloadForm">
                    <div className="modal-dialog">
                        <div className="modal-content">

                            {/* modal header */}
                            <div className="modal-header">
                                <div className="shared-modal-header">
                                    <h4>{dictionary.accessReport}</h4>
                                </div>
                                <button type="button" className="close" data-dismiss="modal">&times;</button>
                            </div>

                            {/* modal body */}
                            <div className="modal-body">
                                <div className="contact-form-box">
                                    <div className="db-box no-background h-100">
                                        <div className="contact-form">
                                            <div className="row">

                                                {this.renderDownloadForm()}

                                                <div className="col-12">

                                                    {/* newsletter checkbox */}
                                                    <div className={`custom-control custom-checkbox ${(data.lang == "ar") ? "custom-checkbox-reverse" : ""}`} style={{ zIndex: 0 }}>
                                                        <input
                                                            checked={sub_to_mailchimp}
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            id="subscribeCheckbox"
                                                            onChange={() => this.setState({ sub_to_mailchimp: !sub_to_mailchimp })}
                                                        />
                                                        <label htmlFor="subscribeCheckbox" className="custom-control-label">
                                                            {dictionary.newsletterSub}
                                                        </label>
                                                    </div>

                                                    <div className="contact-btn-box">

                                                        {this.renderFormFeedback()}

                                                        {/* dl button */}
                                                        <div className="btn-row">
                                                            <div className="btn btn-main" onClick={this.handleDownloadLoggedOut} target="_blank" rel="noopener noreferrer">
                                                                {isDownloading &&
                                                                    <i className="fas fa-circle-notch fa-spin"></i>
                                                                }
                                                                {dictionary.download}
                                                            </div>
                                                            <div className="btn btn-main-outline" onClick={this.Login} data-dismiss="modal">
                                                                {dictionary.loginToView}
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }

}